class VideoLazyLoad {
    constructor() {
        this.videos = document.querySelectorAll('.js-lazy-video');
        this.observer = null;
        this.init();
    }

    init() {
        if (!this.videos.length) {
            return;
        }

        if ('IntersectionObserver' in window) {
            this.initIntersectionObserver();
        } else {
            // Fallback for older browsers - load immediately
            this.loadAllVideos();
        }
    }

    initIntersectionObserver() {
        const options = {
            root: null, // viewport
            rootMargin: '200px', // Load video 200px before entering viewport
            threshold: 0
        };

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.loadVideo(entry.target);
                    this.observer.unobserve(entry.target);
                }
            });
        }, options);

        this.videos.forEach(video => {
            this.observer.observe(video);
        });
    }

    loadVideo(video) {
        const source = video.querySelector('source[data-src]');

        if (!source) {
            return;
        }

        // Move data-src to src
        source.src = source.dataset.src;

        // Load video
        video.load();

        // Add loaded class
        video.classList.add('js-lazy-video--loaded');

        // Optionally: trigger autoplay when video is ready
        if (video.hasAttribute('autoplay')) {
            video.play().catch(() => {
                // Autoplay blocked by browser - ignore
            });
        }
    }

    loadAllVideos() {
        this.videos.forEach(video => {
            this.loadVideo(video);
        });
    }

    // Public method for manual update (if you add new videos dynamically)
    update() {
        const newVideos = document.querySelectorAll('.js-lazy-video:not(.js-lazy-video--loaded)');

        if (this.observer) {
            newVideos.forEach(video => {
                this.observer.observe(video);
            });
        } else {
            newVideos.forEach(video => {
                this.loadVideo(video);
            });
        }
    }
}

// Initialize after DOM loaded
document.addEventListener('DOMContentLoaded', () => {
    window.videoLazyLoad = new VideoLazyLoad();
});

export default VideoLazyLoad;
